import i18n from 'scoreboard/components/i18n'
import OrgGardener from 'scoreboard/organizations/organizations-gardener'
import MultiTreeSelector from 'scoreboard/components/multi-tree-selector'
import constants from 'scoreboard/components/constants'

/**
 * First step of the wizard allowing the user to generate demo data
 * (selecting the orgs that will have data generated)
 */
var DemoDataOrgs = MultiTreeSelector.extend({

	className: 'multi-tree-selector demo-data-orgs',

	initialize: function(options) {
		this.options = options || {}
		this.options.demoData = this.options.demoData || {}
		MultiTreeSelector.prototype.initialize.apply(this, arguments)
	},

	render: function() {
		MultiTreeSelector.prototype.render.apply(this, arguments)

		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})
	},

	createGardener: function() {
		return new OrgGardener({
			descendants: true,
			section: constants.SECTION_SCORECARDS
		})
	},

	context: function() {
		return {
			title: i18n.get('admin.generateDummyData') + ': ' + i18n.get('admin.generateDummyData.orgTree.select'),
			treeIcon: 'browse',
			treeIconClass: 'icon-browse',
			treeLabel: i18n.get('common.organization.organizations'),
			selectedLabel: i18n.get('report.metricComparisonReport.selectedOrganizations'),
			noneSelectedKey: 'admin.group.organizationPermissions.none',
			emptyTreeMessage: i18n.get('common.organization.noOrganizations'),
			cascadeHelpKey: 'admin.generateDummyData.orgTree.cascade'
		}
	},

	oldSelections: function() {
		return this.options.demoData.orgSelections
	},

	saveState: function() {
		var demoData = this.options.demoData
		demoData.orgSelections = this.newSelections()
		this.options.wizard.saveState(demoData)
	},

	submit: function() {
		this.saveState()
		this.options.wizard.next()
	}

})

export default DemoDataOrgs


DemoDataOrgs.__filename__ = 'admin/demo-data/demo-data-orgs.js'
